import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  lastPath: null
};

// ----------------------------------------------------------------------

const slice = createSlice({
  name: 'historyPath',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setPath(state, action) {
      state.lastPath = action.payload;
    }

    // REDUCERS...
  }
});

// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;

// Actions
export const { changeEmployee, setPath } = slice.actions;

// ----------------------------------------------------------------------
